import { useState } from 'react';
import { Paragraph, Text } from 'theme-ui';

export const joinNames = (names: string[]) =>
  names.length <= 1
    ? names.join('')
    : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;

/**
 * Where the default creative will actually show. Names the markets that stock
 * the category and folds away the ones that do not: those are legal targets
 * for an override or a hide, but listing them up front reads as if the banner
 * were about to appear somewhere it cannot.
 */
export default function BannerCoverageNote({
  categoryName,
  stocked,
  unstocked,
  hasArtwork,
}: {
  categoryName: string;
  stocked: string[];
  unstocked: string[];
  hasArtwork: boolean;
}) {
  const [showUnstocked, setShowUnstocked] = useState(false);

  let line: string;
  if (stocked.length === 0) {
    line = `No market currently stocks ${categoryName}.`;
  } else {
    const where = `shown in ${joinNames(
      stocked,
    )}, except where a market below has its own artwork or is hidden.`;
    line = hasArtwork
      ? `${where[0].toUpperCase()}${where.slice(1)}`
      : `Once artwork is set, ${where}`;
  }

  return (
    <Paragraph variant="paragraphSm" sx={{ color: 'neutralDark', mt: 3 }}>
      {line}
      {unstocked.length > 0 && (
        <>
          {' '}
          <Text
            as="button"
            sx={{
              all: 'unset',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={() => setShowUnstocked((current) => !current)}
          >
            {showUnstocked
              ? 'Hide'
              : `${unstocked.length} more market${
                  unstocked.length === 1 ? '' : 's'
                } don’t stock it`}
          </Text>
          {showUnstocked && `: ${joinNames(unstocked)}.`}
        </>
      )}
    </Paragraph>
  );
}
